// in src/Dashboard.tsx
import { Card, CardContent, CardHeader } from "@mui/material";

export const Dashboard = () => (
    <Card>
        <CardHeader title="DELTA Administration" />
        <CardContent>Willkommen im Admin-Bereich</CardContent>
    </Card>
);